// extracted by mini-css-extract-plugin
module.exports = {"breadcrumbs":"breadcrumb_breadcrumbs__8PBJG","divider":"breadcrumb_divider__khEoB","breadcrumb":"breadcrumb_breadcrumb__h5gYC","link":"breadcrumb_link__DNdzY"};